import { useSuspenseQuery } from "@apollo/client";
import { PrimaryFullScreenSpinner, TabLink, TabLinkContainer } from "@repo/ui";
import { NotFoundError } from "@repo/utils";
import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { graphql } from "~/gql/client";
import { opsHead, useOpsTitle } from "~/head";

export const Route = createFileRoute("/__auth/products_/$productId")({
  head: () => opsHead("Product"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  const { productId } = useParams({ strict: false });

  const { data, error } = useSuspenseQuery(
    graphql(`
      query ProductPage($id: ID!) {
        product(id: $id) {
          id
          name
        }
      }
    `),
    { variables: { id: productId ?? "" } },
  );

  const product = data?.product;
  if (error) {
    throw error;
  }

  if (!product) {
    throw new NotFoundError();
  }

  useOpsTitle(`${product.name} - Product`);

  return (
    <AdminPageContainer>
      <AdminPageHeader
        title={product.name}
        subtitle={<div>{product.id}</div>}
      />
      {product.__typename === "FundProduct" && (
        <TabLinkContainer className="mb-10" size="sm">
          <TabLink title="Details" to={`/products/${productId}`} end />
          <TabLink
            title="Unit Prices"
            to={`/products/${productId}/unit-prices`}
          />
        </TabLinkContainer>
      )}
      <Outlet />
    </AdminPageContainer>
  );
}
